// Types for webhook subscriptions
export interface ShopifyWebhookSubscription {
	id: string;
	topic: string;
	type: string;
}

export enum WebhookSubscriptionStatus {
	GOOD = 'GOOD',
	BAD = 'BAD',
}

export interface WebhookSubscriptionHealth {
	key: string;
	value: string;
	description: string;
	id?: string;
	type?: string;
	status: WebhookSubscriptionStatus;
}
